<!-- ContentPage 接收一个底部tab，根据底部tab来渲染页面 -->
<!-- 主要是根据type来渲染页面 -->
<template>
    <div v-if="mBottomTab">
        <!-- 标题栏区域 -->
        <TitleBarView :titlebar="mBottomTab.titlebar" v-if="mBottomTab.titlebar.exist == 1" />
        <div class="titlebar-edit" @click="onClickTitleBar($event, mBottomTab)">编辑标题栏</div>
        <!-- 内容区域 -->
        <div :class="mBottomTab.titlebar.exist == 1 ? 'title-exist' : 'title-not-exist'">
            <ComponentListPage :component_list_config="mBottomTab.titlebar.component_list_config" />
        </div>
    </div>
</template>

<script>
import emitter from '@/utils/eventbus'

import TitleBarView from '@/views/Decoration/DecorationGroup/TitleBar/TitleBarView.vue'
import ComponentListPage from './ComponentListPage.vue'

export default {
    name: "SinglePageView",
    props: ['bottomTab'],
    components: {
        TitleBarView,
        ComponentListPage
    },
    data() {
        return {
            mBottomTab: this.bottomTab
        }
    },
    methods: {
        onClickTitleBar(event, bottomtab) {
            console.log('点击编辑标题栏', bottomtab)
            emitter.emit('onComponentChange', { type: 'titlebar', name: '标题栏', component: bottomtab })
        },
    },
}
</script>
  
<style scoped lang="less">
.titlebar-edit {
    position: absolute;
    left: 100%;
    top: 0px;
    height: 32px;
    line-height: 32px;
    background: rgba(221, 240, 215, 0.4);
    border-radius: 16px;
    padding: 0 16px;
    word-break: keep-all;
    white-space: nowrap;
    font-size: smaller;
    transform: translateX(8px);
    color: #6B7075;
    cursor: pointer;
}
.title-exist {
    height: calc(100% - 40px);
}

.title-not-exist {
    height: 100%;
}
</style>